module.exports = __webpack_public_path__ + "img/state_outcontrol.293c0b6b.png";